import script from "./ProductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductForm.vue?vue&type=script&setup=true&lang=js"

import "./ProductForm.vue?vue&type=style&index=0&id=5d339e58&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d339e58"]])

export default __exports__